// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"NA3_TheComp__SakyK"};